import { render, staticRenderFns } from "./LogoSignature3SecondVideosSection.vue?vue&type=template&id=06bca24e"
import script from "./LogoSignature3SecondVideosSection.vue?vue&type=script&lang=ts"
export * from "./LogoSignature3SecondVideosSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoSignature3SecondVideosSection.vue?vue&type=style&index=0&id=06bca24e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports